import {IPageOption} from '../../interface/paging/paging'
import {IPageMeta} from '../../interface/paging/meta-paging'
import {SORT_BY} from '../enum/order'

export const DEFAULT_META: IPageMeta = {
  page: 1,
  limit: 10,
  total: 0,
  pageCount: 1,
  hasPrevious: false,
  hasNext: false,
}

export const DEFAULT_PAGE_OPTION: IPageOption = {
  limit: 10,
  order: SORT_BY.ASC,
  page: 1,
}

export const GET_ALL: IPageOption = {
  ...DEFAULT_PAGE_OPTION,
  getAll: true,
}

export const GET_ALL_ACTIVE: IPageOption = {
  ...GET_ALL,
  getOnlyActive: true,
}
